import { useState, useEffect } from 'react';
import {
  getAllUsers,
  suspendUser,
  activateUser,
  handleAdminApiError
} from '../services/adminApi';

export const useAdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const usersPerPage = 20;

  const fetchUsers = async (page = 1, search = '', status = 'all') => {
    try {
      setLoading(true);
      setError(null);

      const params = {
        page,
        limit: usersPerPage,
        search: search || undefined,
        status: status !== 'all' ? status : undefined
      };

      const response = await getAllUsers(params);

      // Gérer différents formats de réponse possibles
      if (response.results) {
        setUsers(response.results);
        setTotalPages(Math.ceil(response.count / usersPerPage));
      } else if (Array.isArray(response)) {
        setUsers(response);
        setTotalPages(Math.ceil(response.length / usersPerPage));
      } else {
        setUsers([]);
        setTotalPages(1);
      }

    } catch (err) {
      console.error('Erreur chargement utilisateurs:', err);

      if (err.message?.includes('401') || err.message?.includes('Unauthorized')) {
        setError('Session expirée - veuillez vous reconnecter');
      } else {
        setError(err.message || 'Erreur lors du chargement des utilisateurs');
      }

      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const suspendUserById = async (userId) => {
    try {
      await suspendUser(userId);
      // Recharger la liste
      await fetchUsers(currentPage, searchTerm, filterStatus);
      return { success: true };
    } catch (err) {
      console.error('Erreur suspension utilisateur:', err);
      return { success: false, error: err.message };
    }
  };

  const activateUserById = async (userId) => {
    try {
      await activateUser(userId);
      // Recharger la liste
      await fetchUsers(currentPage, searchTerm, filterStatus);
      return { success: true };
    } catch (err) {
      console.error('Erreur activation utilisateur:', err);
      return { success: false, error: err.message };
    }
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
    fetchUsers(1, term, filterStatus);
  };

  const handleFilterChange = (status) => {
    setFilterStatus(status);
    setCurrentPage(1);
    fetchUsers(1, searchTerm, status);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchUsers(page, searchTerm, filterStatus);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return {
    users,
    loading,
    error,
    searchTerm,
    filterStatus,
    currentPage,
    totalPages,
    suspendUserById,
    activateUserById,
    handleSearch,
    handleFilterChange,
    handlePageChange,
    refetch: () => fetchUsers(currentPage, searchTerm, filterStatus)
  };
};





